import { Component, CUSTOM_ELEMENTS_SCHEMA, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// Services.
import { ClientDivisionsService } from '../../../services/clientDivisions.service';

// Translator.
import { TranslateService, TranslatePipe, TranslateModule } from '@ngx-translate/core';

// Models.
import { VW_ClientDivision } from '../../../models/RES/vwClientDivision';

// Material.
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { NgxSpinnerService, NgxSpinnerModule } from 'ngx-spinner';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { CustomDateAdapter, MY_DATE_FORMATS } from '../../../common/utility/CustomDateAdapter';

@Component({
  selector: 'app-dates-between-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    MatFormFieldModule, 
    MatButtonModule,
    MatDatepickerModule,
    TranslatePipe,
    MatInputModule,
    CommonModule,
    FormsModule,
    MatSelectModule,
    NgxSpinnerModule
  ],
  providers: [
    { provide: DateAdapter, useClass: CustomDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
  ],
  templateUrl: './dates-between-dialog.component.html',
  styleUrl: './dates-between-dialog.component.scss'
})
export class DatesBetweenDialogComponent implements OnInit {
  fromDate: Date | null = null;
  toDate: Date | null = null;

  constructor(
    public dialogRef: MatDialogRef<DatesBetweenDialogComponent>,
    private apiCD: ClientDivisionsService,
    private spinner: NgxSpinnerService
  ) {}

  divisions: VW_ClientDivision[] = [];

  selectedDivisions: number[] = [];
  allSelected: boolean = false;

  ngOnInit(): void {
    this.LoadDivisions();
  }

  toggleAll() {
    if (this.allSelected) {
      this.selectedDivisions = [];
    } else {
      this.selectedDivisions = this.divisions.map(d => d.id);
    }
    this.allSelected = !this.allSelected;
  }

  // Método que revisa si todas las opciones están seleccionadas
  checkSelection() {
    this.allSelected = this.selectedDivisions.length === this.divisions.length;
  }

  private LoadDivisions(){
    this.spinner.show();
    this.apiCD.GetClientDivisionsByCognitoUser().subscribe({
      next: (response) => {
        if (response.success === 1) {
          this.spinner.hide();
          this.divisions = response.data;
        }
      },
      error: (error) => {
        this.spinner.hide();
        const statusCode = error.status;
        const errorMessage = error.error?.message || "An error occurred trying to connect to web services.";

        console.error(`Error ${statusCode}`, error);
      },
    });
  }

  onConfirm(): void {
    if (this.fromDate && this.toDate && this.selectedDivisions.length > 0) {
      this.dialogRef.close({ fromDate: this.fromDate, toDate: this.toDate, divisions: this.selectedDivisions });
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
